// extracted by mini-css-extract-plugin
export default {"centeredContainer":"Graph_centeredContainer__eKpq7","notificationTitle":"Graph_notificationTitle__56SeK","subTitle":"Graph_subTitle__4QJi1"};